export const createImage = (): HTMLImageElement => new Image();
